import { render, staticRenderFns } from "./orderReturn.vue?vue&type=template&id=2e8c2e66&"
import script from "./orderReturn.vue?vue&type=script&lang=js&"
export * from "./orderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports